import type { PhysicalAppointmentDetail } from 'types/entity'
import { parseDisplayNameList } from 'utils/dotNetDate'
import { Comments } from './Comments'

/** Port of `CreatePysAppointmentView` + `GetPhyAppointment`. */
export function PhysicalAppointmentView({
  appointment,
  appointmentId,
}: {
  appointment: PhysicalAppointmentDetail
  appointmentId: string
}) {
  const fieldExecutives = parseDisplayNameList(appointment.FieldExecutives)
  const collaborators = parseDisplayNameList(appointment.Collaborators)

  return (
    <div className="entity-main">
      <h5>Appointment Details</h5>

      <div className="row">
        <div className="col-8">
          <div className="details-header">
            <h4 className="lead-title">
              <span className="k">Related To:</span> {appointment.geGeoEntityName || '—'}
            </h4>
          </div>

          <div className="lead-content">
            <h3>{appointment.Title}</h3>
            {appointment.Description && <p>{appointment.Description}</p>}

            <div className="detail-grid">
              <Detail label="Start Date" value={appointment.StartDate} />
              <Detail label="End Date" value={appointment.EndDate} />
              <Detail label="Field Executives" value={fieldExecutives} />
              <Detail label="Collaborators" value={collaborators} />
              <Detail label="Completed Date" value={appointment.CompletedOn} />
              <Detail label="Owner" value={appointment.auDisplayName} />
              <Detail label="Created On" value={appointment.CreatedDate} />
            </div>
          </div>
        </div>

        <div className="col-4">
          <Comments taskId={appointmentId} variant="physicalapt" />
        </div>
      </div>
    </div>
  )
}

function Detail({ label, value }: { label: string; value: string }) {
  return (
    <div className="detail-item">
      <span className="k">{label}:</span>
      <span>{value || '—'}</span>
    </div>
  )
}
